import Gen from '@helper/Gen';
import BOGen from '@helper/BOGen';

var bo_router = [
  {path: "", name: "Dashboard", component:()=> import("@backend/Dashboard.vue")},
  {path: "profile", name: "Profile", component:()=> import("@backend/Profile.vue")},
  {path: "import-employee/:id?", name: "ImportEmployee", component:()=> import("@backend/ImportEmployee.vue"), meta: {accessMenu:true}},
  {path: "inbox", name: "Inbox", component:()=> import("@backend/Inbox.vue"), meta: {accessMenu:true}},
  {path: "working-facility/:id", name: "WorkingFacility", component:()=> import("@backend/WorkingFacility.vue")},  
  {
    path: "additional-facility/:id?",
    name: "AdditionalFacility",
    component: () => import("@backend/AdditionalFacilityList.vue"), 
    meta: {
      accessMenu: true,
      group: 'AdditionalFacility'
    }
  },
  {
    path: "additional-facility-init",
    name: "AdditionalFacilityInit",
    component: () => import("@backend/AdditionalFacilityInit.vue"),
    meta: {
      group: 'AdditionalFacility'
    }
  },
  {
    path: "additional-facility-approval/:id",
    name: "AdditionalFacilityApproval",
    component: () => import("@backend/AdditionalFacilityInit.vue"),
    meta: {
      accessMenu: false,
      group: 'AdditionalFacility'
    }
  },
  {
    path: "working-facility-confirmation/:id",
    name: "WorkingFacilityConfirmation",
    component: () => import("@backend/WorkingFacility.vue"),
    meta: {
      accessMenu: false,
      group: 'AdditionalFacility'
    }
  },
  {
    path: "movement-list/:id?",
    name: "MovementList",
    component: () => import("@backend/MovementList.vue"),
    meta: {
      accessMenu: false,
      group: 'Movement'
  }},
  {
    path: "movement-init/:id?",
    name: "MovementInit",
    component: () => import("@backend/MovementInit.vue"),
    meta: {
      group: 'Movement'
    }
  },
  {
    path: "offboarding",
    name: "Offboarding",
    component: () => import("@backend/OffboardingList.vue"),
    meta: {
      accessMenu: true,
      group: 'Offboarding'
    }
  },
  {path: "offboarding-init/:id?", name: "OffboardingInit", component:()=> import("@backend/OffboardingInit.vue"),meta:{
    group: 'Offboarding'
  }},
  {
    path: "offboarding-approval/:id",
    name: "OffboardingApproval",
    component: () => import("@backend/OffboardingApproval.vue"),
    meta: {
      module: ["ApprovalCC"],
      group: 'Offboarding'
    }
  },
  {path: "flow-status-report", name: "FlowStatusReport", component:()=> import("@backend/FlowStatusReport.vue"), meta: {accessMenu:true, group:'Report'}},
  {
    path: "flow-status-report/:id/:apc_id?",
    name: "StatusReportDetail",
    meta: {
      accessMenu: true,
      group: 'Report'
    },
    component: () => import("@backend/WorkingFacility.vue")
  },
  
  {
    path: "view-employee-data",
    name: "ViewEmployeeData",
    component: () => import("@backend/ViewEmployeeData.vue"),
    meta: {
      accessMenu: true,
      group: 'Report'
    }
  },
  {
    path: "department/:id?",
    name: "MrSubGroup",
    component: () => import("@backend/MrSubGroup.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "mr-access-door/:id?",
    name: "MrAccessDoor",
    component: () => import("@backend/MrAccessDoor.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "position-title/:id?",
    name: "MrJobTitle",
    component: () => import("@backend/MrJobTitle.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "facility-setup/:id?",
    name: "MrFacilitySetup",
    component: () => import("@backend/MrFacilitySetup.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "template/:id?",
    name: "MrTemplate",
    component: () => import("@backend/MrTemplate.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "ga-form/:id?",
    name: "MrGaForm",
    component: () => import("@backend/MrGaForm.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "checklist/:id?",
    name: "MrFormChecklist",
    component: () => import("@backend/MrFormChecklist.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "cost-center/:id?",
    name: "MrCostCenter",
    component: () => import("@backend/MrCostCenter.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },
  {
    path: "settings/:id?",
    name: "Settings",
    component: () => import("@backend/Settings.vue"),
    meta: {
      accessMenu: true,
      group: "Master"
    }
  },

  // User Management
  {
    path: "users/:id?",
    name: "Users",
    component: () => import("@backend/Users.vue"),
    meta: {
      accessMenu: true,
      group: "UserManagement"
    }
  },
  {
    path: "access-level/:id?",
    name: "AccessLevel",
    component: () => import("@backend/AccessLevel.vue"),
    meta: {
      accessMenu: true,
      group: "UserManagement"
    }
  },
  {
    path: "audit-trail/:id?",
    name: "AuditTrail",
    component: () => import("@backend/AuditTrail.vue"),
    meta: {
      accessMenu: true,
      listOnly: true
    }
  },
  {
    path: "onboarding-checklist/:id?",
    name: "OnboardingChecklist",
    component: () => import("@backend/OnboardingChecklist.vue"),
    meta: {
      accessMenu: true,
      listOnly: true
    }
  },
  // 404
  {path: '*', redirect: {name:"Dashboard"}},
];

var menuBypassRole = ["Profile", "Dashboard"]

bo_router.map((v)=>{
  v.beforeEnter = (to, _from, next)=>{
    var user = BOGen.user()
    if(!user || !Gen.getCookie('botk')){
      return next({name:"Login",query:{url:to.fullPath}})
    }    
    BOGen.apirest('/ProfileCheck', { cwid: user.cwid }, (err, resp) => {
      if(err) return console.error(err);

      const passwordDB = resp.data_profile.password
      const positionDB = resp.data_profile.position
      const levelDB = resp.data_profile.access_level
      const status = resp.data_profile.employee_status
      const accessMenuDB = resp.level.al_access_menu.split(',')
      
      if(
        passwordDB != user.password || 
        positionDB != user.position || 
        levelDB != user.access_level || 
        !status || 
        accessMenuDB.length != user.al_access_menu.length
      ) { 
        Gen.putCookie("botk", "")
        Gen.putCookie("user", "")

        return next({name:"Login",query:{url:to.fullPath}})
      }
    })
    if(menuBypassRole.indexOf(to.name)>-1) return next()
    if(user.ae_al_id==0) return next()
    if(to.meta.accessMenu){
      if(!BOGen.isMenu(to.name)) return next({name:"Dashboard"})
    }
    if(to.meta.withLock&&BOGen.isLockAuthorization()){
      return next({name:"Dashboard"})
    }
    if(to.meta.module){
      if(!BOGen.isModule(to.meta.module)) return next({name:"Dashboard"})
    }
    next()
  }
})

var data = [
  {
    name: "Login",
    path: "login",
    component: () => import("@backend/Login.vue"),
    beforeEnter: (_to, _from, next)=>{
      var user = BOGen.user()
      if(user && Gen.getCookie('botk')) return next({name:"Dashboard"})
      next()
    }
  },
  // Logout
  {
    name: "Logout",
    path: "logout",
    beforeEnter:(_to, _form, next)=>{
      Gen.putCookie("user")
      Gen.putCookie("botk")
      next({name:"Login"})
    }
  },
  {
    path:"",
    component: () => import('@/layout/BoLayout.vue'),
    redirect: {name:'Dashboard'},
    children: bo_router
  },
]

export default data